module.exports = __webpack_public_path__ + "static/img/img_wulianwang_05.5029cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_wulianwang_05.png
// module id = 1X8V
// module chunks = 19